
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    import useTranslation from 'next-translate/useTranslation';
import { DEFAULT_LISTING_PAGE } from '@unreserved-frontend-v2/modules/listings/utils/routing/constants';
import { Button } from '@unreserved-frontend-v2/ui/button/button';
import { Footer } from '@unreserved-frontend-v2/ui/footer/footer';
import { FooterMobile } from '@unreserved-frontend-v2/ui/footer/footer-mobile';
import { ResponsiveWidth } from '@unreserved-frontend-v2/ui/responsive-width/responsive-width';
import { SEOHeader } from '@unreserved-frontend-v2/ui/SEO-header/desktop';
import { ORIGIN_HOST } from '@unreserved-frontend-v2/utils/local-storage/constants';
import AppHeader from '../../../components/header/app-header';
import { MainMenuKey } from '../../../components/hooks/use-menu-items';
import Step1Component from '../../../components/pages/learn-more/buying-simplified/step-1-component';
import { Step2Component } from '../../../components/pages/learn-more/buying-simplified/step-2-component';
import Step3Component from '../../../components/pages/learn-more/buying-simplified/step-3-component';
import Step4Component from '../../../components/pages/learn-more/buying-simplified/step-4-component';
import Step5Component from '../../../components/pages/learn-more/buying-simplified/step-5-component';
import HeroComponent from '../../../components/pages/learn-more/hero-component';
import OverviewComponent from '../../../components/pages/learn-more/overview-component';
export function BuyingSimplified() {
    const { t } = useTranslation('inner-pages');
    const listingBreadcrumbValues = {
        title: t('buying-simplified.buying-simplified'),
        breadcrumbItems: [
            { label: t('buying-simplified.learn-more'), id: 'learn-more' },
            { label: t('buying-simplified.buying-simplified'), id: 'buying-simplified' },
        ],
        canonicalLink: `${ORIGIN_HOST}/learn-more/buying-simplified`
    };
    const sections = [
        {
            stepNumber: '01',
            subTitle: t('buying-simplified.down-payment')
        },
        {
            stepNumber: '02',
            subTitle: t('buying-simplified.begin-home-search')
        },
        {
            stepNumber: '03',
            subTitle: t('buying-simplified.make-offer')
        },
        {
            stepNumber: '04',
            subTitle: t('buying-simplified.offer-acceptance')
        },
        {
            stepNumber: '05',
            subTitle: t('buying-simplified.closing')
        },
    ];
    const components = [
        <Step1Component key={sections[0].stepNumber} stepNumber={sections[0].stepNumber} subTitle={sections[0].subTitle}/>,
        <Step2Component key={sections[1].stepNumber} stepNumber={sections[1].stepNumber} subTitle={sections[1].subTitle}/>,
        <Step3Component key={sections[2].stepNumber} stepNumber={sections[2].stepNumber} subTitle={sections[2].subTitle}/>,
        <Step4Component key={sections[3].stepNumber} stepNumber={sections[3].stepNumber} subTitle={sections[3].subTitle}/>,
        <Step5Component key={sections[4].stepNumber} stepNumber={sections[4].stepNumber} subTitle={sections[4].subTitle}/>,
    ];
    return (<>
      <AppHeader pageKey={MainMenuKey.LEARN_MORE}/>
      <div className="bg-shades-25">
        <ResponsiveWidth className="py-6">
          <SEOHeader settings={listingBreadcrumbValues}/>

          <HeroComponent title={t('buying-simplified.buying-simplified')} content={t('buying-simplified.hero-content')} containerClassName="text-center h-[377px] w-full mt-[20px]" image="/static/images/buying-simplified-hero.jpg">
            <Button href={DEFAULT_LISTING_PAGE} className="mb-5 mt-11 w-[272px] text-sm">
              {t('buying-simplified.hero-button')}
            </Button>
          </HeroComponent>

          <OverviewComponent title={t('buying-simplified.five-steps')} content={t('buying-simplified.five-steps-content')} box={sections} containerClassName="mt-[34px]" boxItemsClassName="pt-[42px]"/>

          {components}
        </ResponsiveWidth>
      </div>
      <Footer containerClassName="hidden md:block"/>
      <FooterMobile containerClassName="block md:hidden"/>
    </>);
}
BuyingSimplified.getInitialProps = async () => ({});
const __Next_Translate__Page__1955d79d36b__ = BuyingSimplified;

    export default __appWithI18n(__Next_Translate__Page__1955d79d36b__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: false,
      loadLocaleFrom: __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
    });
  